import script from "./SkillsTree.vue?vue&type=script&setup=true&lang=js"
export * from "./SkillsTree.vue?vue&type=script&setup=true&lang=js"

import "./SkillsTree.vue?vue&type=style&index=0&id=6e0b9074&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e0b9074"]])

export default __exports__